/* Laboratoire v84 (copie de ebk-lp.js, passage au paiement accéléré). Landing collier EduBark : carrousel d'avis, cartes d'offre et vidéos chargées à l'approche (template product.collier-lp). */
(function () {
  // Carrousel : défilement natif (scroll-snap), flèches et points
  function initCarousel(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('[data-ebk-lp-track]');
    var dots = root.querySelector('[data-ebk-lp-dots]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.children);

    function step() { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth; }
    function current() { return Math.round(track.scrollLeft / (step() || 1)); }
    function go(i) { track.scrollTo({ left: Math.max(0, Math.min(cards.length - 1, i)) * step(), behavior: 'smooth' }); }

    if (dots) {
      cards.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Avis ' + (i + 1));
        b.addEventListener('click', function () { go(i); });
        dots.appendChild(b);
      });
    }
    var prev = root.querySelector('[data-ebk-lp-prev]');
    var next = root.querySelector('[data-ebk-lp-next]');
    function sync() {
      var i = current();
      if (dots) Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === i); });
      if (prev) prev.style.visibility = i <= 0 ? 'hidden' : '';
      if (next) next.style.visibility = i >= cards.length - 1 ? 'hidden' : '';
    }
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    sync();
  }

  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    var f = format || '{{amount}} $';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return v.replace('.', ',');
      if (k === 'amount_no_decimals') return String(Math.round(cents / 100));
      if (k === 'amount_no_decimals_with_comma_separator') return String(Math.round(cents / 100));
      return v;
    });
  }

  // Offre : prix recalculés selon les couleurs choisies, chaque carte envoie directement au checkout
  function initOffer(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var mapEl = root.querySelector('[data-ebk-lp-variants]');
    var variants = mapEl ? JSON.parse(mapEl.textContent) : {};
    var fmt = (root.dataset.money || '').replace(/<[^>]*>/g, '');
    var guide = root.dataset.guide;
    var gift = root.dataset.gift;
    var giftMin = parseInt(root.dataset.giftMin, 10) || 2;
    var cartNow = null;
    function readCart() {
      cartNow = fetch('/cart.js', { credentials: 'same-origin', __cartGuardBypass: true, __ebkCart: true })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { readCart(); near.disconnect(); }
      }, { rootMargin: '1200px 0px' });
      near.observe(root);
    } else readCart();
    window.addEventListener('pageshow', function (e) { if (e.persisted) readCart(); });

    root.querySelectorAll('[data-ebk-lp-tier]').forEach(function (tier) {
      var qty = parseInt(tier.dataset.qty, 10) || 1;
      var discount = parseFloat(tier.dataset.discount) || 0;
      var selects = tier.querySelectorAll('[data-ebk-lp-color]');
      var btn = tier.querySelector('[data-ebk-lp-buy]');
      var err = tier.querySelector('[data-ebk-lp-err]');

      function picked() {
        if (!selects.length) {
          var only = variants[Object.keys(variants)[0]];
          return only ? Array(qty).fill(only) : [];
        }
        return Array.prototype.map.call(selects, function (s) { return variants[s.value]; });
      }

      function render() {
        var list = picked();
        if (list.some(function (v) { return !v; })) return;
        // Shopify applique le rabais collier par collier, arrondi à la cent inférieure
        var total = 0, compare = 0;
        list.forEach(function (v) { total += v.price - Math.floor(v.price * discount / 100); compare += v.compare; });
        tier.querySelector('[data-unit]').textContent = money(Math.round(total / qty), fmt);
        tier.querySelector('[data-total]').textContent = money(total, fmt);
        var cmp = tier.querySelector('[data-compare]');
        var save = tier.querySelector('[data-save]');
        cmp.textContent = money(compare, fmt);
        cmp.hidden = compare <= total;
        save.querySelector('[data-save-amt]').textContent = money(compare - total, fmt);
        save.hidden = compare <= total;
      }
      selects.forEach(function (s) { s.addEventListener('change', render); });
      render();

      btn.addEventListener('click', function () {
        var list = picked();
        err.hidden = true;
        if (!list.length || list.some(function (v) { return !v || !v.available; })) {
          err.textContent = root.dataset.errSoldout || 'Cette couleur est épuisée présentement. Choisissez-en une autre.';
          err.hidden = false;
          return;
        }
        // Colliers de même couleur fusionnés : un seul AddToCart Facebook pour le geste
        var merged = {};
        list.forEach(function (v) { merged[v.id] = (merged[v.id] || 0) + 1; });
        var items = Object.keys(merged).map(function (id) { return { id: id, quantity: merged[id] }; });
        // Bonus par /cart/update.js, jamais /cart/add.js (pas d'AddToCart pour un cadeau), comme volume-offer.js
        var bonuses = {};
        if (guide) bonuses[guide] = 1;
        if (gift && qty >= giftMin) bonuses[gift] = 1;
        function post(url, body) {
          return fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
            __cartGuardBypass: true,
            __ebkCart: true // le tiroir panier ne s'ouvre pas : on part au checkout
          }).then(function (res) { return res.ok ? res.json() : res.json().then(function (e) { throw e; }); });
        }
        btn.disabled = true;
        btn.textContent = btn.dataset.loading;
        // Checkout direct avec exactement l'offre choisie, 2 requêtes au lieu de 3 : les colliers par /cart/add.js,
        // puis une seule mise à jour pour le reste du panier. Panier inconnu : vidé d'abord, comme avant.
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        (cartNow || Promise.resolve(null))
          .then(function (cart) {
            return (cart ? Promise.resolve() : post('/cart/clear.js', {}))
              .then(function () { return post('/cart/add.js', { items: items }); })
              .then(function () { return cart; });
          })
          .then(function (cart) {
            // Laisse le suivi des pages marquer le panier avant de quitter (2 s max)
            var tag = window.__suiviCartTag || Promise.resolve();
            return Promise.race([tag, new Promise(function (r) { setTimeout(r, 2000); })]).then(function () { return cart; });
          })
          .then(function (cart) {
            // Une seule mise à jour pour le reste : anciens articles à 0, colliers à la quantité exacte, bonus à 1
            var up = {};
            ((cart && cart.items) || []).forEach(function (it) { up[it.variant_id] = 0; });
            Object.keys(merged).forEach(function (id) { up[id] = merged[id]; });
            Object.keys(bonuses).forEach(function (id) { up[id] = 1; });
            return post('/cart/update.js', { updates: up });
          })
          .then(function () { window.location.href = base + 'checkout'; })
          .catch(function (e) {
            err.textContent = (e && (e.description || e.message)) || root.dataset.errGeneric || 'Une erreur est survenue. Réessayez.';
            err.hidden = false;
            btn.disabled = false;
            btn.textContent = btn.dataset.label;
          });
      });
      // Retour arrière depuis le checkout : la page revient du cache avec le bouton encore « en cours »
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) { btn.disabled = false; btn.textContent = btn.dataset.label; }
      });
    });
  }

  // Vidéo : rien n'est téléchargé avant qu'elle approche de l'écran, pause quand elle en sort
  var videoObserver = 'IntersectionObserver' in window && new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.src) v.src = v.dataset.src;
        var p = v.play();
        if (p) p.catch(function () {});
      } else if (v.src) {
        v.pause();
      }
    });
  }, { rootMargin: '300px 0px' });

  function initVideo(v) {
    if (v.dataset.ready) return;
    v.dataset.ready = '1';
    if (videoObserver) videoObserver.observe(v);
    else { v.src = v.dataset.src; v.autoplay = true; }
  }

  // Boutons vers l'offre : défilement doux au lieu du saut de l'ancre #order.
  // Chaque section charge ce fichier : un seul écouteur pour toute la page.
  if (!window.__ebkLpScroll) {
    window.__ebkLpScroll = true;
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('.ebk-lp-cta__btn[href="#order"]');
      var target = link && document.getElementById('order');
      if (!target) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - margin;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  function init(scope) {
    scope.querySelectorAll('[data-ebk-lp-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-ebk-lp-offer]').forEach(initOffer);
    scope.querySelectorAll('[data-ebk-lp-lazy]').forEach(initVideo);
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
